export default {
    path: 'task_management',
    name: 'task_management',
    component: r => require.ensure([], () => r(require('./index.vue')), 'task_management'),
    redirect: {name: 'task_management_list'},
    children: [
        {
            path: 'task_management_list',
            name: 'task_management_list',
            component: r => require.ensure([], () => r(require('./list.vue')), 'task_management_list'),
        }
    ]
}
